import App from 'next/app'
import React from 'react'

//* Providers
import { UIProvider, DataProvider, LanguageProvider, UserProvider, CartProvider } from 'context'

//* Components
import AppHeader from 'components/common/AppHeader'
import AppFooter from 'components/common/AppFooter'
import CookiePopup from 'components/common/CookiePopup'
import Preloader from 'components/common/preloader'
import Popup from 'components/common/Popup'

//* Helpers
import { getData, getPageParams, config, getUser } from 'helpers'

//* styles
import 'styles/icons/style.css'
import 'styles/select.css'
import 'styles/font.css'

class MyApp extends App {
	static async getInitialProps({ Component, ctx, router, ...props }) {
		//! Checking If First Request or Not
		if (!process.browser) {
			//! Default States
			const newState = {
				pages: {},
				global: {},
			}

			let userData = {
				isLoggedIn: false,
			}

			//! Getting User Data
			userData = await getUser(router.locale, userData, ctx)

			//! Checking is private page and not logged in
			userData.redirect && ctx.res.redirect(userData.redirectUrl || '/sign-in')

			//! Getting Page Data
			const data = await getData({ lang: router.locale, state: newState, router: ctx, getPageParams: true })

			return {
				pageProps: {
					...data,
					browser: false,
				},
				userProps: userData.newState,
			}
		} else {
			return {
				pageProps: {
					pageParams: getPageParams({ lang: router.locale, router: ctx }),
					browser: true,
				},
			}
		}
	}

	render() {
		const { Component, pageProps, router, userProps } = this.props

		return (
			<LanguageProvider>
				<UIProvider>
					<DataProvider newData={pageProps}>
						<UserProvider userProps={userProps}>
							<CartProvider>
								{!config.withoutHeaderFooterPages.includes(router.pathname) ? (
									<>
										<Popup />
										<Preloader />
										<CookiePopup />
										<AppHeader />
									</>
								) : null}

								<section className='min-height'>
									<Component {...pageProps} config={config.routes} selectedLang={router.locale} />
									<svg style={{ height: 0 }}>
										<clipPath id='my-clip-path' clipPathUnits='objectBoundingBox'>
											<path d='M0.548,0.972 C0.485,0.958,0.408,0.94,0.32,0.94 C0.258,0.94,0.108,0.719,0.108,0.719 S0.061,0.861,0.038,0.894 Q0.033,0.9,0.029,0.9 C0.02,0.9,0.01,0.88,0,0.84 C-0.014,0.784,-0.014,0.334,0,0.39 A0.288,12,0,0,0,0.038,0.444 C0.06,0.411,0.108,0.27,0.108,0.27 S0.258,0.491,0.32,0.491 C0.408,0.491,0.485,0.509,0.548,0.523 C0.652,0.547,0.715,0.562,0.726,0.47 L0.726,0.47 H0.726 L0.914,0.123,0.914,0.572 L0.726,0.919 C0.719,0.973,0.695,0.99,0.654,0.99 C0.626,0.99,0.591,0.982,0.548,0.972 M0.936,0.312 L0.936,0.088 C0.937,0.088,0.953,0.039,0.959,0 C0.967,-0.045,0.989,0.082,0.99,0.088 L0.989,0.537 C0.989,0.536,0.967,0.405,0.96,0.449 C0.953,0.489,0.937,0.537,0.936,0.537'></path>
										</clipPath>
									</svg>
								</section>
								{!config.withoutHeaderFooterPages.includes(router.pathname) ? <AppFooter /> : null}
							</CartProvider>
						</UserProvider>
					</DataProvider>
				</UIProvider>
			</LanguageProvider>
		)
	}
}

export default MyApp
